import { render, staticRenderFns } from "./IdeasListWidget.vue?vue&type=template&id=34d41c90"
import script from "./IdeasListWidget.vue?vue&type=script&lang=js"
export * from "./IdeasListWidget.vue?vue&type=script&lang=js"
import style0 from "./IdeasListWidget.vue?vue&type=style&index=0&id=34d41c90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports